<template>
  <div v-if="alert" class="my-4">
    <OfferStatus v-if="offer" :payload="offer" buttonClass="offer-status-button" />
  </div>
</template>
<script>
import OfferStatus from '@/components/OfferStatus'

export default {
  name: 'FeedContentApplicantActivity',
  components: {
    OfferStatus
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      alert: this.payload,
      offer: null
    }
  },
  created () {
    this.$network_utils
      .getOfferBy({
        applicant_id: this.payload.resources.applicant.resource_id,
        position_id: this.payload.resources.position.id
      })
      .then(response => {
        this.offer = response[0]
      })
  }
}
</script>
